import { PANEL_CLASS } from "../report-styles";

interface Props {
  title: string;
  value: string;
  detail: string;
}

export const ReportCard = ({ title, value, detail }: Props) => (
  <div className={`${PANEL_CLASS} p-5`}>
    <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">{title}</div>
    <div className="mt-2 text-2xl font-bold text-spend-ink">{value}</div>
    <p className="mt-1 text-xs text-gray-500">{detail}</p>
  </div>
);
